import { ApolloClient } from '@apollo/client/core';

interface GraphClientState {
  graphClient: ApolloClient<any>;
}

const getInitialState = () => {
  return {
    graphClient: null
  };
};

export const graphClient = (state: GraphClientState = getInitialState()) => state;
